export var checkboxPotentialFieldPaths = [
    'onboarding.durability.incidenceType.GREENHOUSE_GAS',
    'onboarding.durability.incidenceType.BIODIVERSITY',
    'onboarding.durability.incidenceType.WATER',
    'onboarding.durability.incidenceType.TRASH',
    'onboarding.durability.incidenceType.SOCIAL_AND_PERSON',
];
